import { render, staticRenderFns } from "./ForumPostBody.vue?vue&type=template&id=afa71f22&"
import script from "./ForumPostBody.vue?vue&type=script&lang=js&"
export * from "./ForumPostBody.vue?vue&type=script&lang=js&"
import style0 from "./ForumPostBody.vue?vue&type=style&index=0&id=afa71f22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports